module.exports = __webpack_public_path__ + "static/media/job_eco_friendly.59e8838b.svg";